import { Currency, getIsOssino } from "../../../../sharedfiles/helper";

const isOssino = getIsOssino()

export const sportGameType = [
  { id: 2, label: "Sports", value: "SPORTS" },
  { id: 1, label: "Virtuals", value: "VIRTUALS" },
];
export const GameType = sportGameType;
export const subBetType = [
  { id: 1, label: "Next Bet", value: "NEXT_BET" },
  { id: 2, label: "Hot Multis", value: "HOT_MULTIS" },
  { id: 3, label: "Customised Accas", value: "CUSTOMISED_ACCAS" },
  { id: 4, label: "One Click Bet", value: "ONE_CLICK_BET" },
  { id: 5, label: "Virtuals", value: "VIRTUALS" },
  { id: 6, label: "Vaix Recommendations", value: "VAIX_RECOMMENDATIONS" },
  { id: 7, label: "Dynamic Multis", value: "DYNAMIC_MULTI" },
  { id: 8, label: "None", value: "NONE" }
]
export const gamesGameType = [
  { id: 3, label: "Casino", value: "CASINO" },
  { id: 4, label: "NE Games", value: "NE_GAMES" },
  { id: 5, label: "Lottery", value: "LOTTERY" },
]
export const gamesGameTypeCasino = [
  { id: 3, label: "Casino", value: "CASINO" },
  { id: 4, label: "NE Games", value: "NE_GAMES" },
]
export const BetType = [
  // { id: 1, label: "Combi", value: "COMBI" },
  // { id: 2, label: "Custom", value: "CUSTOM" },
  { id: 4, label: "Single", value: "SINGLE" },
  { id: 3, label: "Multi", value: "MULTI" },
  // { id: 5, label: "Split", value: "SPLIT" },
  // { id: 6, label: "System", value: "SYSTEM " },
];

export const WatchlistTypes = [
  { id: 1, label: "Manual", value: "MANUAL" },
  { id: 2, label: "Automated", value: "AUTOMATED" },
]
export const sportsInBetHistory = [
  { id: 1, label: "Soccer", value: "Soccer" },
]
export const SportsBetType = [
  { id: 1, label: "Combi", value: "COMBI" },
  { id: 2, label: "Custom", value: "CUSTOM" },
  { id: 4, label: "Single", value: "SINGLE" },
  { id: 3, label: "Multi", value: "MULTI" },
  { id: 5, label: "Split", value: "SPLIT" },
  { id: 6, label: "System", value: "SYSTEM " },
];

export const CasinoType = [
  { id: 1, label: "Category", value: "CATEGORY", tooltip: "Showing Category" },
  // { id: 2, label: "Game Code", value: "GAME_CODE" },
  { id: 3, label: "Game Name", value: "GAME_NAME", tooltip: "Showing Game Name" },
  { id: 4, label: "Aggregator", value: "PROVIDER_NAME", tooltip: "Showing Aggregator" },
  { id: 5, label: "Provider", value: "SUB_PROVIDER_NAME", tooltip: "Showing Provider" },
];

export const BetStatus = [
  { id: 1, label: "Half Won", value: "HalfWon" },
  { id: 2, label: "half Lost", value: "HalfLost" },
  { id: 3, label: "Rejected", value: "Rejected" },
  { id: 4, label: "Cancelled", value: "Cancelled" },
  { id: 5, label: "Void", value: "Void" },
  { id: 6, label: "Cashed Out", value: "CashedOut" },
  { id: 7, label: "Running", value: "Running" },
  { id: 8, label: "Won", value: "Won" },
  { id: 9, label: "Lost", value: "Lost" },
  { id: 10, label: "InitFailed", value: "InitFailed" },
  { id: 11, label: "Init", value: "Init" },
  // { id: 12, label: "Live", value: "Live" },
  { id: 13, label: "Settled", value: "Settled" },
];

export const Betfold = [
  { id: 2549, label: "1", value: "SINGLE" },
  { id: 9243, label: "2", value: "DOUBLE" },
  { id: 9324, label: "3", value: "TREBLE" },
  { id: 9757, label: "Multiple 4+", value: "MULTIPLE" },
];
export const userRole = [
  { id: 1, label: "Agent", value: "AGENT" },
  { id: 2, label: "Online User", value: "ONLINE_PLAYER" },
  { id: 3, label: "Cashier", value: "CASHIER" },
  { id: 4, label: "player", value: "PLAYER" },
]

export const isCutBonus = [
  { id: 1, label: "ONE CUT", value: "ONECUT" },
  { id: 2, label: "TWO CUT", value: "TWOCUT" },
]

export const betHistoryUserType = [
  { id: 1, label: "Real User", value: "REAL_USER" },
  { id: 2, label: "Test User", value: "TEST_USER" },
]

export const betHistoryAccountStatus = [
  { id: 1, label: "Active", value: "ACTIVE" },
  { id: 2, label: "Suspended", value: "SUSPENDED" },
]

export const betDecisionStatusOptions = [
  { id: 1, label: "All", value: "all" },
  { id: 2, label: "Accepted", value: "Accepted" },
  { id: 3, label: "Rejected", value: "Rejected" },
]

export const Sport = [
  { id: 957, label: "Aussie Rules", value: "AussieRules" },
  { id: 97867, label: "Badminton", value: "Badminton" },
  { id: 987967, label: "Baseball", value: "Baseball" },
  { id: 9796, label: "Basket ball", value: "BasketBall" },
  { id: 97697, label: "Basketball 3x3", value: "Basketball3x3" },
  { id: 379, label: "Beach VolleyBall", value: "BeachVolleyBall" },
  { id: 7369, label: "Casinos", value: "Casinos" },
  { id: 769, label: "Cricket", value: "Cricket" },
  { id: 769, label: "Darts", value: "Darts" },
  { id: 769, label: "Field Hockey", value: "FieldHockey" },
  { id: 976, label: "Football", value: "Football" },
  { id: 7699, label: "Formula 1", value: "Formula1" },
  { id: 79, label: "Futsal", value: "Futsal" },
  { id: 47369, label: "Golf", value: "Golf" },
  { id: 439, label: "Handball", value: "Handball" },
  { id: 439, label: "Horse Racing", value: "HorseRacing" },
  { id: 639, label: "Ice Hockey", value: "Ice Hockey" },
  { id: 7969, label: "Tennis", value: "Tennis" },
  { id: 7679, label: "Kabaddi", value: "Kabaddi" },
  { id: 979, label: "Snooker", value: "Snooker" },
  { id: 68739, label: "Soccer", value: "Soccer" },
  { id: 769, label: "Squash", value: "Squash" },
  { id: 7369, label: "American Football", value: "AmericanFootball" },
  { id: 75739, label: "Rugby", value: "Rugby" },
  { id: 7379, label: "ESports", value: "ESports" },
  { id: 379, label: "Volley Ball", value: "VolleyBall" },
  { id: 7699, label: "Table Tennis", value: "Table Tennis" },
];

export const mainTableHeaders = [
  "Bet Id",
  "Booking Code",
  "Short Bet ID",
  "Bet Status",
  "Bet Decision Status",
  "Bet Decision Reviewer Name",
  "Bet Decision Reason",
  "Rejection Code",
  "Placed On",
  "Settled On",
  "Age Of Account",
  "Customer Id",
  "User Role",
  "User Name",
  "First Name",
  "Last Name",
  "Surname",
  "Phone",
  "Stake Factor",
  "Event Name",
  `Match status`,
  "Betfold",
  "Bet Type",
  "Place Bet Type",
  "Sub Bet Type",
  "Cut Value",
  'One Cut Eligibility',
  'Two Cut Eligibility',
  "Game Type",
  "Currency",
  "Odds",
  `Stake Before Tax`,
  ...(isOssino ? ["Stake Before Tax (USD)"] : []),
  `Stake Tax Percentage % `,
  `Stake Tax Amount ${Currency()}`,
  ...(isOssino ? ["Stake Tax Amount (USD)"] : []),
  `Stake After Tax ${Currency()}`,
  ...(isOssino ? ["Stake After Tax (USD)"] : []),
  // `Real Stake`,
  // `Bonus Stake`,
  "Parlay Bonus Amount ",
  ...(isOssino ? ["Parlay Bonus Amount (USD)"] : []),
  "Bonus Type",
  `Winnings Tax Percentage % `,
  `Winnings Tax Amount ${Currency()}`,
  ...(isOssino ? ["Winnings Tax Amount (USD)"] : []),
  `Potential Winnings`,
  ...(isOssino ? ["Potential Winnings (USD)"] : []),
  "Total Payout Without Bonus",
  ...(isOssino ? ["Total Payout Without Bonus (USD)"] : []),
  "Total Payout With Bonus",
  ...(isOssino ? ["Total Payout With Bonus (USD)"] : []),
  `Total Payout ${Currency()}`,
  ...(isOssino ? ["Total Payout (USD)"] : []),
  `Bonus Max Win Amount ${Currency()}`,
  ...(isOssino ? ["Bonus Max Win Amount (USD)"] : []),
  "Bonus Max Win Percentage % ",
  "Agent ID",
  "Agent Name",
  "Provider Name",
  // "Number Of Combination",
  // "Win/Lost/Void",
  // "Groups",
  "Aggregator",
  "Provider",
  "Game Name",
  "Category",
  // "Game Code",
];

export const gamesTableHeaders = [
  "Bet Id",
  "Bet Status",
  "Age Of Account",
  "Customer Id",
  "User Role",
  "User Name",
  "First Name",
  "Last Name",
  "Surname",
  "Phone",
  "Game Type",
  "Aggregator",
  "Provider",
  "Game Name",
  "Category",
  "Event Name",
  "Placed On",
  "Settled On",
  "Currency",
  "Bonus Amount",
  ...(isOssino ? ["Bonus Amount (USD)"] : []),
  "Payout",
  ...(isOssino ? ["Payout (USD)"] : []),
  "Stake",
  ...(isOssino ? ["Stake (USD)"] : []),
  `Stake Tax Percentage % `,
  `Stake After Tax ${Currency()}`,
  ...(isOssino ? ["Stake After Tax (USD)"] : []),
  `Stake Tax Amount  ${Currency()}`,
  ...(isOssino ? ["Stake Tax Amount (USD)"] : []),
  `Winnings Tax Percentage % `,
  `Winnings Tax Amount ${Currency()}`,
  ...(isOssino ? ["Winnings Tax Amount (USD)"] : []),
  "Total Payout",
  ...(isOssino ? ["Total Payout (USD)"] : []),
  "Total Payout With Bonus",
  ...(isOssino ? ["Total Payout With Bonus (USD)"] : []),
  "Bonus Max Win Amount",
  ...(isOssino ? ["Bonus Max Win Amount (USD)"] : []),
  "Bonus Max Win Percentage % ",
  "Place Bet Type",
  "Agent ID",
  "Agent Name",
]

export const CasinoGamesTableHeaders = [
  "Session ID",
  "Session Start Time",
  "Session End Time",
  "Round ID",
  "Start Time",
  "End Time",
  "Customer ID",
  "User Role",
  "User Name",
  "First Name",
  "Last Name",
  "Surname",
  "Phone",
  "Currency",
  // "Bonus Amount",
  "Payout",
  ...(isOssino ? ["Payout (USD)"] : []),
  "Stake",
  ...(isOssino ? ["Stake (USD)"] : []),
  "Stake Tax Percentage",
  "Stake After Tax",
  ...(isOssino ? ["Stake After Tax (USD)"] : []),
  "Stake Tax Amount",
  ...(isOssino ? ["Stake Tax Amount (USD)"] : []),
  "Winning Tax Percentage",
  "Winning Tax Amount",
  ...(isOssino ? ["Winning Tax Amount (USD)"] : []),
  // "Cash Winning Tax Amount",
  // "Cash Winnings After Tax",
  // "Bonus Winnings Tax Amount",
  // "Bonus Winnings After Tax",
  "Total Payout",
  ...(isOssino ? ["Total Payout (USD)"] : []),
  "Total Payout with Bonus",
  ...(isOssino ? ["Total Payout with Bonus (USD)"] : []),
  "Bonus Max Win Amount",
  ...(isOssino ? ["Bonus Max Win Amount (USD)"] : []),
  "Bonus Max Win Percentage",
  "Agent ID",
  "Agent Name",
];

export const CasinoGamesTableHeadersInfo = [
  "Showing Session ID",
  "Showing Session Start Time",
  "Showing Session End Time",
  "Showing Round ID",
  "Showing Start Time",
  "Showing End Time",
  "Showing Customer ID",
  "Showing User Role",
  "Showing User Name",
  "Showing First Name",
  "Showing Last Name",
  "Showing Surname",
  "Showing Phone",
  "Showing Currency",
  // "Showing Bonus Amount",
  "Showing Payout",
  ...(isOssino ? ["Showing Payout (USD)"] : []),
  "Showing Stake",
  ...(isOssino ? ["Showing Stake (USD)"] : []),
  "Showing Stake Tax Percentage",
  "Showing Stake After Tax",
  ...(isOssino ? ["Showing Stake After Tax (USD)"] : []),
  "Showing Stake Tax Amount",
  ...(isOssino ? ["Showing Stake Tax Amount (USD)"] : []),
  "Showing Winning Tax Percentage",
  "Showing Winning Tax Amount",
  ...(isOssino ? ["Showing Winning Tax Amount (USD)"] : []),
  // "Showing Cash Winning Tax Amount",
  // "Showing Cash Winnings After Tax",
  // "Showing Bonus Winnings Tax Amount",
  // "Showing Bonus Winnings After Tax",
  "Showing Total Payout",
  ...(isOssino ? ["Showing Total Payout (USD)"] : []),
  "Showing Total Payout with Bonus",
  ...(isOssino ? ["Showing Total Payout with Bonus (USD)"] : []),
  "Showing Bonus Max Win Amount",
  ...(isOssino ? ["Showing Bonus Max Win Amount (USD)"] : []),
  "Showing Bonus Max Win Percentage",
  "Showing Agent ID",
  "Showing Agent Name",
];

export const CasinoBetHistoryRoundsHeadersInfo = [
  "Showing Round ID",
  "Showing Transaction ID",
  // "Showing Transaction Status",
  "Showing Bet ID",
  "Showing Game ID",
  "Showing Game Type",
  "Showing Aggregator Name",
  "Showing Provider Name",
  "Showing Game Name",
  "Showing Category",
  "Showing Placed On Date & Time",
  "Showing Settled On Date & Time",
  "Showing Bet Status",
  "Showing Stake Before Tax",
  ...(isOssino ? ["Showing Stake Before Tax (USD)"] : []),
  "Showing Stake Tax Amount",
  ...(isOssino ? ["Showing Stake Tax Amount (USD)"] : []),
  "Showing Stake After Tax",
  ...(isOssino ? ["Showing Stake After Tax (USD)"] : []),
  "Showing Winnings Tax Amount",
  ...(isOssino ? ["Showing Winnings Tax Amount (USD)"] : []),
  "Showing Total Payout",
  ...(isOssino ? ["Showing Total Payout (USD)"] : []),
  "Showing Bet Placement Type",
  "Showing Transaction Type",
  "Showing Bet Transaction Type",
];



export const bettingHistoryInfo = [
  "Showing Bet Id",
  "Showing Booking Code",
  "Showing Short Bet Id",
  "Showing Bet Status",
  "Showing Bet Decision Status",
  "Showing Bet Decision Reviewer Name",
  "Showing Bet Decision Reason",
  "Showing Rejection Code",
  "Showing bets Placed On",
  "Showing the bets Settled On",
  "Showing Age Of Account",
  "Showing Customer Id",
  "Showing User Role",
  "Showing User Name",
  "Showing First Name",
  "Showing Last Name",
  "Showing Surname",
  "Showing Phone",
  "Showing Stake Factor",
  "Showing Event Name",
  `Showing Match Status Eg: Prematch/Live/Pre+Live`,
  "Showing Betfold",
  "Showing Bet Type",
  "Showing Place Bet Type",
  "Showing Sub Bet Type",
  "Showing Cut value",
  'Showing One Cut Eligibility',
  'Showing Two Cut Eligibility',
  "Showing Game Type",
  "Showing Currency",
  "Showing Odds",
  `Showing Stake Before Tax`,
  ...(isOssino ? ["Showing Stake Before Tax (USD)"] : []),
  "Showing Stake Tax Percentage",
  "Showing Stake Tax Amount",
  ...(isOssino ? ["Showing Stake Tax Amount (USD)"] : []),
  "Showing Stake After Tax",
  ...(isOssino ? ["Showing Stake After Tax (USD)"] : []),
  // `Showing Real Stake`,
  // `Showing Bonus Stake`,
  "Showing Parlay Bonus Amount ",
  ...(isOssino ? ["Showing Parlay Bonus Amount (USD)"] : []),
  "Showing Bonus Type",
  "Showing Winnings Tax Percentage",
  "Showing Winnings Tax Amount",
  ...(isOssino ? ["Showing Winnings Tax Amount (USD)"] : []),
  `Showing Potential Winnings`,
  ...(isOssino ? ["Showing Potential Winnings (USD)"] : []),
  "Showing Total Payout Without Bonus",
  ...(isOssino ? ["Showing Total Payout Without Bonus (USD)"] : []),
  "Showing Total Payout With Bonus",
  ...(isOssino ? ["Showing Total Payout With Bonus (USD)"] : []),
  `Showing Total Payout`,
  ...(isOssino ? ["Showing Total Payout (USD)"] : []),
  "Showing Bonus Max Win Amount",
  ...(isOssino ? ["Showing Bonus Max Win Amount (USD)"] : []),
  "Showing Bonus Max Win Percentage",
  "Showing Agent Id",
  "Showing Agent Name",
  "Showing Provider Name",
  // "Showing Number Of Combination",
  // "Showing Win Lost Void Outcomes Count",
  // "Showing Groups",
  "Showing Aggregator",
  "Showing Provider",
  "Showing Game Name",
  "Showing Category",
  // "Showing Game Code",
]
export const gamesHistoryInfo = [
  "Showing Bet Id",
  "Showing Bet Status",
  "Showing Age Of Account",
  "Showing Customer Id",
  "Showing User Role",
  "Showing User Name",
  "Showing First Name",
  "Showing Last Name",
  "Showing Surname",
  "Showing Phone",
  "Showing Game Type",
  "Showing Aggregator",
  "Showing Provider",
  "Showing Game Name",
  "Showing Category",
  "Showing Event Name",
  "Showing bets Placed On",
  "Showing the bets Settled On",
  "Showing Currency",
  "Showing Bonus Amount",
  ...(isOssino ? ["Showing Bonus Amount (USD)"] : []),
  `Showing Payout`,
  ...(isOssino ? ["Showing Payout (USD)"] : []),
  `Showing Stake`,
  ...(isOssino ? ["Showing Stake (USD)"] : []),
  "Showing Stake Tax Percentage",
  "Showing Stake After Tax",
  ...(isOssino ? ["Showing Stake After Tax (USD)"] : []),
  "Showing Stake Tax Amount",
  ...(isOssino ? ["Showing Stake Tax Amount (USD)"] : []),
  "Showing Winnings Tax Percentage",
  "Showing Winnings Tax Amount",
  ...(isOssino ? ["Showing Winnings Tax Amount (USD)"] : []),
  "Showing Total Payout",
  ...(isOssino ? ["Showing Total Payout (USD)"] : []),
  "Showing Total Payout With Bonus",
  ...(isOssino ? ["Showing Total Payout With Bonus (USD)"] : []),
  "Showing Bonus Max Win Amount",
  ...(isOssino ? ["Showing Bonus Max Win Amount (USD)"] : []),
  "Showing Bonus Max Win Percentage",
  "Showing Place Bet Type",
  "Showing Agent ID",
  "Showing Agent Name",
]

export const betIdHeaders = [
  "Bet Selection ID",
  "Event Name",
  "Event start date & Time",
  "Event Status",
  "League Name",
  "Market Name",
  "Odds",
  "Sports Name",
  "Selection Name",
  "Selection Status",
  "Winning Number",
  "Boosted Odds Value",
  "Is Boosted Odds",
];


export const betIdHeaderInfo = [
  "Showing Bet Selection ID",
  "Showing Event Name",
  "Showing Event start date & Time",
  "Showing Event Status",
  "Showing League Name",
  "Showing Market Name",
  "Showing Odds",
  "Showing Sports Name",
  "Showing Selection Name",
  "Showing Selection Status",
  "Showing Winning Number",
  "Showing Boosted Odds Value",
  "Showing Is Boosted Odds",
];

export const betSortables = {
  "Bet Status": {
    key: "betStatus",
    type: "str"
  },
  "Rejection Code": {
    key: "rejectionCode",
    type: "str"
  },
  "Age Of Account": {
    key: "ageOfAccount",
    type: "num"
  },
  "Customer Id": {
    key: "userId",
    type: "num"
  },
  "Stake Factor": {
    key: "stakeFactor",
    type: "num"
  },
  "Betfold": {
    key: "betType",
    type: "num"
  },
  "Currency": {
    key: "currencyCode",
    type: "str"
  },
  "Odds": {
    key: "odds",
    type: "num"
  },
  "Stake": {
    key: "stake",
    type: "num"
  },
  "Real Stake": {
    key: "stake_real",
    type: "num"
  },
  "Bonus Stake": {
    key: "stake_bonus",
    type: "num"
  },
  "Parlay Bonus Amount ": {
    key: "parlayWinning",
    type: "num"
  },
  "Bonus Type": {
    key: "bonusPayout",
    type: "num"
  },
  "Potential Payout": {
    key: "potentialPayout",
    type: "num"
  },
  "Total Payout": {
    key: "payout",
    type: "num"
  },
  "Placed On": {
    key: "placedDate",
    type: "date"
  },
  "Settled On": {
    key: "settledDate",
    type: "date"
  },
}

export const GamesbetSortables = {
  "Bet Status": {
    key: "betStatus",
    type: "str"
  },
  "Rejection Code": {
    key: "rejectionCode",
    type: "str"
  },
  "Age Of Account": {
    key: "ageOfAccount",
    type: "num"
  },
  "Customer Id": {
    key: "userId",
    type: "num"
  },
  "Stake Factor": {
    key: "stakeFactor",
    type: "num"
  },
  "Betfold": {
    key: "betType",
    type: "num"
  },
  "Currency": {
    key: "currencyCode",
    type: "str"
  },
  "Odds": {
    key: "odds",
    type: "num"
  },
  "Stake": {
    key: "stake",
    type: "num"
  },
  "Real Stake": {
    key: "stake_real",
    type: "num"
  },
  "Bonus Stake": {
    key: "stake_bonus",
    type: "num"
  },
  "Bonus Amount": {
    key: "parlayWinning",
    type: "num"
  },
  "Bonus Type": {
    key: "bonusPayout",
    type: "num"
  },
  "Potential Payout": {
    key: "potentialPayout",
    type: "num"
  },
  "Payout": {
    key: "payout",
    type: "num"
  },
  "Placed On": {
    key: "placedDate",
    type: "date"
  },
  "Settled On": {
    key: "settledDate",
    type: "date"
  },
}